export default __webpack_public_path__ + "static/media/icon3.f697ceb6.png";